import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { portfolioItems } from '../../../data/portfolio-items';

import { translate } from '@/translations';

export const PortfolioDetails = () => {
  const { t } = useTranslation('portfolio');
  const { key } = useParams<{ key: string }>();
  const portfolioItem = portfolioItems.find((item) => item.key.toLowerCase() === key.toLowerCase());

  return (
    <div className="w-auto">
      <div>
        <div className="bg-backgroundItems py-20">
          <div className="flex justify-center items-center my-5">
            <div className="flex justify-center items-center bg-white rounded-xl shadow-2xl p-5">
              <img
                src={portfolioItem.logoSrc}
                alt={portfolioItem.title}
                className="w-24 object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex justify-center items-center uppercase py-10 text-center">
            <h1 className="text-3xl font-semibold tracking-[.25em]">{portfolioItem?.title}</h1>
          </div>
          <div className="flex justify-center text-center">
            <p className="w-3/4 text-text leading-6 md:leading-8 xl:leading-10 text-xl md:text-2xl whitespace-pre-line">
              {translate(portfolioItem.introKey)}
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-5 mt-6">
            {portfolioItem.icons.map((icon, index) => (
              <div className="flex items-center gap-2" key={index}>
                <img src={icon.img} className="size-8" alt="Technology icon" loading="lazy" />
                <p className="text-black/60 whitespace-nowrap text-xs">{icon.caption}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col h-[300px] md:h-[50vh] relative">
          <div className="bg-backgroundItems grow"></div>
          <div className="grow bg-white"></div>

          <div className="absolute z-2 top-0 w-full h-full flex justify-center items-center">
            <div className="bg-white rounded-3xl shadow-2xl p-5">
              <img
                src={portfolioItem.mockupSrc}
                alt={portfolioItem.title}
                className="h-full max-h-[50vh] object-scale-down"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center py-24 gap-10">
          <div className="p-5 md:w-1/2">
            <div className="text-4xl font-semibold my-5">
              <h1>{t('projectOverview')}</h1>
            </div>
            <div>
              <p className="font-light leading-6 md:leading-8 xl:leading-10 text-xl md:text-2xl whitespace-pre-line">
                {translate(portfolioItem.descriptionKey)}
              </p>
            </div>
          </div>
          <div>
            <img
              src={portfolioItem.sidePictureSrc}
              className="h-full max-h-[45vh] object-scale-down rounded-xl"
              loading="lazy"
            />
          </div>
        </div>

        <div className="flex justify-center items-center bg-black text-white py-20">
          <div className="text-center md:w-3/4 xl:w-2/3 p-5">
            <h1 className="text-4xl font-semibold mb-5">{t('projectGoal')}</h1>
            <p className="font-light leading-6 md:leading-8 xl:leading-10 text-xl md:text-2xl whitespace-pre-line">
              {translate(portfolioItem.goalsKey)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
